import type { VacationRequestsRepositoryT } from "../../domain/ports/vacationRequests.repository";

type GetRequestDetailParamsT = {
  vacationRequestsRepository: VacationRequestsRepositoryT;
  requestId: string;
  colaboraInstanceId: string;
};

export const getRequestDetail = async ({
  vacationRequestsRepository,
  requestId,
  colaboraInstanceId,
}: GetRequestDetailParamsT) => {
  return await vacationRequestsRepository.getRequestDetail(
    requestId,
    colaboraInstanceId,
  );
};
